<template>
  <div class="owal-toggle-button__container">
    <div
      v-for="(segment, index) in segments"
      :key="segment.title"
      :class="segmentClass(index)"
      @click="click(index)"
      :id="segment.id ? `${segment.id}` : ''"
      >
      <font-awesome-icon
        v-if="segment.icon"
        :icon="segment.icon"
        size="sm"
        :style="`color: ${segment.iconColor};`"
        />
      <div style="margin-left: .5rem;"> {{ segment.title }} </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'owal-toggle-button',
  data () {
    return {
      selectedIndex: 0,
    }
  },
  props: {
    defaultIndex: {
      type: Number,
      default: 0,
    },
    callback: {
      type: Function,
      default: undefined,
    },
    live: {
      type: Boolean,
    },
    segments: {
      type: Array,
    },
  },
  methods: {
    click (index) {
      this.selectedIndex = index
      if (this.callback) {
        this.callback()
      } else this.$emit('change', index)
    },
    segmentClass (index) {
      const base = 'owal-toggle-button__segment'
      const end = index === 0 ? ' left' : index === this.segments.length - 1 ? ' right' : ''
      const active = this.selectedIndex === index ? ' active' : ''

      return `${base}${end}${active}`
    },
  },
  mounted () {
    this.selectedIndex = this.defaultIndex
  },
}
</script>

<style scoped>

.owal-toggle-button__container {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  margin: 0;
  flex-grow: 1;
}

.owal-toggle-button__container i {
  height: auto;
}

/** Both segments, active and inactive. */
.owal-toggle-button__segment {
  border: 1px solid #E0E0E0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: all 300ms ease;
  font-weight: normal;
  opacity: 0.35;
  padding: 0.35rem 0.5rem;
  margin: 0;
  height: 100%;
  flex-shrink: 0;
  flex-grow: 0;
}

/** Left and Right Segments */
.left {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-right: -1px;
}

.right {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

/* --- When either segment is active --- */
.active {
  background-color: #E0E0E0;
  font-weight: bold;
  opacity: 1;
}

/** Inactive Segments, when hovered */
.owal-toggle-button__segment:hover.active {
  color: gray;
}

.owal-toggle-button__segment:hover {
  transform: scale(1.05);
  opacity: 1;
}

.owal-toggle-button__label {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.owal-toggle-button__container_small {
  font-weight: normal;
  padding: 0;
  margin: 0;
  font-size: 1rem;
  line-height: 1rem;
  flex-grow: 0;
  flex-shrink: 1;
}

.owal-toggle-button__container:hover > .active {
  opacity: 0.35;
}

</style>
